<template>
  <div class="animated fadeIn">
    <!-- <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Título</strong>
          </div>
          <b-row>
            <b-col lg="12">
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import { globalesMixin } from "@/components/mixins/globalesMixin";

export default {
  name: "Dashboard",
  mixins: [tablasMixin, globalesMixin],
  data: function() {
    return {
    };
  },
  methods: {
  },
  mounted: function() {
  }
};
</script>
